import debounce from 'lodash/debounce';

export default {
  data: function () {
    return {
      infiniteList: null
    }
  },
  mounted() {
    this.handleDebouncedScroll = debounce(this.handleScroll, 100);
    window.addEventListener('scroll', this.handleDebouncedScroll);
  },
  methods: {
    handleScroll() {
      if(!this.infiniteList) {
        this.infiniteList = this.$el.querySelector('.article-list__items');
        if(!this.infiniteList) {
          window.removeEventListener('scroll', this.handleDebouncedScroll);
          console.log('No infinite list found')
          return false;
        }
      }

      console.warn(document.documentElement.scrollTop, this.infiniteList.offsetTop, this.infiniteList.offsetHeight, window.innerHeight, document.documentElement.offsetHeight);

      if (document.documentElement.scrollTop > this.infiniteList.offsetTop + this.infiniteList.offsetHeight - (window.innerHeight * 0.95) ) {
        console.log("reached infinite load more");
        this.displayMorePosts();
      }
    },
    removeInfiniteListener() {
      console.error("remoing listener");
      window.removeEventListener('scroll', this.handleDebouncedScroll);
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/vue/infiniteScroll.js